import axios from "axios";
import { API_BASE_URL } from "../constants/api-urls";
import SuperAdminStorageService from "./SuperAdminStorageService";
import { applyBulkImportTimeout } from "../constants/bulkUpload";

const superAdminApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 90000,
});

const isSuperAdminSessionAuthError = (err) => {
  const msg = String(err?.response?.data?.error || err?.response?.data?.message || "").toLowerCase();
  return (
    msg.includes("super admin authentication required") ||
    msg.includes("invalid or expired super admin session") ||
    msg.includes("super admin session invalid") ||
    msg.includes("super admin account is inactive")
  );
};

superAdminApi.interceptors.request.use((config) => {
  applyBulkImportTimeout(config);
  const token = SuperAdminStorageService.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  return config;
});

superAdminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    const requestUrl = String(err?.config?.url || "");
    const isSuperAdminRequest = requestUrl.includes("/super-admin/");

    if (
      err.response?.status === 401 &&
      isSuperAdminRequest &&
      isSuperAdminSessionAuthError(err)
    ) {
      const path = window.location.pathname || "";
      SuperAdminStorageService.clearAuth();
      if (path.startsWith("/super-admin") && path !== "/super-admin/login") {
        window.location.href = "/super-admin/login";
      }
    }
    return Promise.reject(err);
  },
);

export default superAdminApi;
